module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./locales/index.js
// module id = 77
// module chunks = 0